export class Task {
	public static parse(data: ITask): Task {
		const task: Task = new Task();
		if (data.assignments !== undefined) {
			task.assignments = data.assignments;
		}
		if (data.bucketId !== undefined) {
			task.bucketId = data.bucketId;
		}
		if ((data.dueDateTime !== undefined) && (data.dueDateTime !== null)) {
			task.dueDateTime = new Date(data.dueDateTime);
		}
		if (data.id !== undefined) {
			task.id = data.id;
		}
		if (data.orderHint !== undefined) {
			task.orderHint = data.orderHint;
		}
		if (data.percentComplete !== undefined) {
			task.percentComplete = data.percentComplete;
		}
		if (data.planId !== undefined) {
			task.planId = data.planId;
		}
		if ((data.startDateTime !== undefined) && (data.startDateTime !== null)) {
			task.startDateTime = new Date(data.startDateTime);
		}
		if (data.title !== undefined) {
			task.title = data.title;
		}
		// etagはDELETEやPATCHに必須
		const etag: string = (data as any)["@odata.etag"];
		if (etag !== undefined) {
			task.etag = etag;
		}
		return task;
	}

	// https://docs.microsoft.com/ja-jp/graph/api/resources/plannertask?view=graph-rest-1.0
	public etag: string = '';
	public assignments: any;
	public bucketId: string = "";
	public dueDateTime: Date | null = null;
	public id: string = "";
	public orderHint: string = "";
	public percentComplete: number = 0;
	public planId: string = "";
	public startDateTime: Date | null = null;
	public title: string = "";

	public isAssignment(userId: string): boolean {
		if ((this.assignments === undefined) || (this.assignments === null)) {
			return false;
		}
		if ((this.assignments[userId] === undefined) || (this.assignments[userId] === null)) {
			return false;
		}
		return true;
	}
}

export interface ITask {
	assignments?: any;
	bucketId?: string;
	dueDateTime?: Date | null;
	id?: string;
	orderHint?: string;
	percentComplete?: number;
	planId?: string;
	startDateTime?: Date | null;
	title?: string;
}

// tslint:disable-next-line: max-classes-per-file
export class TaskPost {
	public planId?: string;
	public bucketId?: string;
	public title?: string;
	public assignmentsUserId?: string;
	public startDateTime?: Date | null;
	public dueDateTime?: Date | null;
	public percentComplete?: number;

	public getJson(): string {
		if (!this.isValid()) {
			return '';
		}
		const data: { [key: string]: any; } = {};
		data.planId = this.planId;
		data.bucketId = this.bucketId;
		data.title = this.title;
		if (this.assignmentsUserId !== undefined) {
			data.assignments = {};
			data.assignments[this.assignmentsUserId] = {
				'@odata.type': '#microsoft.graph.plannerAssignment',
				'orderHint': ' !'
			};
		}
		if (this.startDateTime !== undefined) {
			data.startDateTime = (this.startDateTime === null) ? null : this.startDateTime.toISOString();
		}
		if (this.dueDateTime !== undefined) {
			data.dueDateTime = (this.dueDateTime === null) ? null : this.dueDateTime.toISOString();
		}
		if (this.percentComplete !== undefined) {
			data.percentComplete = this.percentComplete;
		}
		return JSON.stringify(data);
	}

	private isValid(): boolean {
		return ((this.planId !== undefined) && (this.bucketId !== undefined) && (this.title !== undefined));
	}
}

// tslint:disable-next-line: max-classes-per-file
export class TaskPatch {
	public title?: string;
	public assignmentsUserId?: string;
	public startDateTime?: Date | null;
	public dueDateTime?: Date | null;
	public percentComplete?: number;

	public getJson(): string {
		if (!this.isValid()) {
			return '';
		}
		const data: { [key: string]: any; } = {};
		if (this.title !== undefined) {
			data.title = this.title;
		}
		if (this.assignmentsUserId !== undefined) {
			// 担当者の追加処理
			data.assignments = {};
			data.assignments[this.assignmentsUserId] = {
				'@odata.type': '#microsoft.graph.plannerAssignment',
				'orderHint': ' !'
			};
			// TODO 担当者を削除する場合は以下の通り
			// data.assignments[this.assignmentsUserId] = null;
		}
		// TODO graph apiの時間はデフォルトで10
		if (this.startDateTime !== undefined) {
			data.startDateTime = (this.startDateTime === null) ? null : this.startDateTime.toISOString();
		}
		if (this.dueDateTime !== undefined) {
			data.dueDateTime = (this.dueDateTime === null) ? null : this.dueDateTime.toISOString();
		}
		if (this.percentComplete !== undefined) {
			data.percentComplete = this.percentComplete;
		}
		return JSON.stringify(data);
	}
	private isValid(): boolean {
		return (
			(this.title !== undefined) ||
			(this.assignmentsUserId !== undefined) ||
			(this.startDateTime !== undefined) ||
			(this.dueDateTime !== undefined) ||
			(this.percentComplete !== undefined)
		);
	}
}

